import {
  IEpIconsRegularList,
  IEpIconsSolidList,
  regularIconsList,
  solidIconsList,
  IEpIconProps,
} from './EpIconList';

export interface IEpIconVariantProps {
  iconSize?: number;
  customClasses?: string;
}

const iconsList: IEpIconsRegularList | IEpIconsSolidList = {
  ...regularIconsList,
  ...solidIconsList,
};

export const EpIcon: React.FC<IEpIconProps> = ({
  iconSize = 16,
  iconName,
  customClasses,
}: IEpIconProps) => {
  if (!(iconName in iconsList)) return <></>;
  const IconComponentTag: React.FC<IEpIconVariantProps> =
    iconsList[iconName as keyof typeof iconsList];

  return <IconComponentTag iconSize={iconSize} customClasses={customClasses} />;
};
